<div class="card">
  <div class="card-header card-no-border">
    <div class="header-top">
      <h5>Total Users</h5>
      <div class="dropdown icon-dropdown">
        <button class="btn dropdown-toggle" type="button" (click)="toggle()"><app-feather-icons [icon]="'more-horizontal'"></app-feather-icons></button>
        <div class="dropdown-menu dropdown-menu-end" [class.show]="show"><a class="dropdown-item" href="#">Weekly</a><a class="dropdown-item" href="#">Monthly</a><a class="dropdown-item" href="#">Yearly</a></div>
      </div>
    </div>
  </div>
  <div class="card-body pt-0">
    <ul class="user-list">
      <li>
        <div class="user-icon primary">
          <div class="user-box"><i class="font-primary" data-feather="user-plus"></i></div>
        </div>
        <div>
          <h5 class="mb-1">178,098</h5>
          <span class="font-primary d-flex align-items-center"><i class="icon-arrow-up icon-rotate me-1"> </i><span class="f-w-500">+30.89</span></span>
        </div>
      </li>
      <li>
        <div class="user-icon success">
          <div class="user-box"><i class="font-success" data-feather="user-minus"></i></div>
        </div>
        <div>
          <h5 class="mb-1">178,098</h5>
          <span class="font-danger d-flex align-items-center"><i class="icon-arrow-down icon-rotate me-1"></i><span class="f-w-500">-08.89</span></span>
        </div>
      </li>
    </ul>
  </div>
</div>
